import { render, staticRenderFns } from "./InvoicesReport.vue?vue&type=template&id=59dd002e&scoped=true&"
import script from "./InvoicesReport.vue?vue&type=script&lang=js&"
export * from "./InvoicesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dd002e",
  null
  
)

export default component.exports